<div>
  <transition name="fade">
    <div v-if="active">
      <slot></slot>
    </div>
  </transition>
</div>
